import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ConfigurationManagerService } from './configuration-manager.service';
import { IncidentResponse } from '../models/incident.model';

@Injectable({
  providedIn: 'root',
})
export class IncidentService {
  constructor(private api: ApiService) {}
  getIncidentFindAndCountAllFromOrganization(): Observable<IncidentResponse> {
    const url =
      ConfigurationManagerService.settings.BaseURL +
      ConfigurationManagerService.settings.IncidentCountAllFromOrganization;
    const body = {
      order: [['createdAt', 'ASC']],
      where: {
        status: ['ACTIVE', 'PENDING'],
        type: ['PERIMETER', 'GEOFENCE'],
      },
      limit: 10000,
    };
    return this.api.post<IncidentResponse>(url, body);
  }
}
